/**
 * リクエストID管理
 * 
 * APIリクエストごとに一意のIDを生成・管理し、
 * ログに含めることでトレーサビリティを確保します。
 */

/**
 * リクエストIDを生成
 */
export function generateRequestId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`
}

/**
 * 現在のリクエストIDを保持する変数
 * 各APIリクエストごとに設定される
 */
let currentRequestId: string | null = null

/**
 * リクエストIDを設定
 */
export function setRequestId(id: string): void {
  currentRequestId = id
}

/**
 * 現在のリクエストIDを取得
 */
export function getRequestId(): string | null {
  return currentRequestId
}

/**
 * リクエストIDをクリア
 */
export function clearRequestId(): void {
  currentRequestId = null
}
